import { render, staticRenderFns } from "./NewCouponItem.vue?vue&type=template&id=bb2c1874"
import script from "./NewCouponItem.vue?vue&type=script&lang=js"
export * from "./NewCouponItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports